/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cdo_Act_Confirm_DeliveryInputs */

const vi_cdo_act_confirm_delivery = /** @type {(inputs: Cdo_Act_Confirm_DeliveryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xác nhận giao xong`)
};

/**

* @param {Cdo_Act_Confirm_DeliveryInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const cdo_act_confirm_delivery = /** @type {((inputs?: Cdo_Act_Confirm_DeliveryInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cdo_Act_Confirm_DeliveryInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cdo_act_confirm_delivery(inputs)
});